import React from 'react';

const EdgeEditor = ({ graphData, edgeForm, setEdgeForm, addEdge }) => {
  return (
    <div className="edge-editor">
      <h5>Add Edge</h5>
      <div className="add-edge-controls">
        <div className="edge-form">
          <div className="form-group">
            <label htmlFor="source-node">Source Node:</label>
            <select
              id="source-node"
              value={edgeForm.source}
              onChange={(e) => setEdgeForm({ ...edgeForm, source: e.target.value })}
              className="edge-input"
            >
              <option value="">Select source node...</option>
              {graphData.nodes.map(node => (
                <option key={node.id} value={node.id}>
                  {node.label} (ID: {node.id})
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="target-node">Target Node:</label>
            <select
              id="target-node"
              value={edgeForm.target}
              onChange={(e) => setEdgeForm({ ...edgeForm, target: e.target.value })}
              className="edge-input"
            >
              <option value="">Select target node...</option>
              {graphData.nodes.map(node => (
                <option key={node.id} value={node.id}>
                  {node.label} (ID: {node.id})
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="edge-weight">Weight:</label>
            <input
              id="edge-weight"
              type="number"
              min="1"
              value={edgeForm.weight}
              onChange={(e) => setEdgeForm({ ...edgeForm, weight: parseInt(e.target.value) || 1 })}
              className="edge-input"
            />
          </div>
          
          <button 
            className="add-edge-btn"
            onClick={addEdge}
          >
            ➕ Add Edge
          </button>
        </div>
        
        <p className="add-edge-info">
          Select source and target nodes, set the weight, then click "Add Edge" to create a connection.
        </p>
      </div>
    </div>
  );
};

export default EdgeEditor;
